<template>
  <b-table
    :fields="fields"
    :items="items"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    show-empty
    striped
    hover
  >
    <template #cell(acoes)="item">
      <b-dropdown variant="outline-default">
        <b-dropdown-item
          @click="baixar(item.item)"
          v-if="item.item.nomeDocumento"
        >
          {{ $t("GERAL.BAIXAR") }}
        </b-dropdown-item>
        <b-dropdown-item
          @click="visualizar(item.item)"
          v-if="item.item.conteudoDocumento"
        >
          {{ $t("GERAL.VISUALIZAR") }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <modal />
  </b-table>
</template>

<script>
// utils e aux
import { START_LOADING, STOP_LOADING } from "@/store/Store";
// import { base64ToArrayBuffer } from "@/common/utils/pdf";
import mensagem from "@/common/utils/mensagem";

// services
import ParecerDescritivoService from "@/common/services/parecer-descritivo/parecer-descritivo.service.js";
import pdf from "@/common/utils/pdf";

// componentes

export default {
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      fields: [
        {
          key: "anoLetivoDescricao",
          label: this.$t("ACADEMICO.ANO"),
          sortable: true,
        },
        {
          key: "turmaDescricao",
          label: this.$t("ACADEMICO.PARECER_DESCRITIVO"),
          sortable: true,
        },
        {
          key: "segmentacaoDescricao",
          label: this.$t("ACADEMICO.SEGMENTACAO"),
          sortable: true,
        },
        {
          key: "acoes",
          label: this.$t("GERAL.ACOES"),
        },
      ],
    };
  },
  methods: {
    baixar(item) {
      this.$store.dispatch(START_LOADING);
      ParecerDescritivoService.baixarPDF(item.id)
        .then((result) => {
          let bytes = pdf.base64ToArrayBuffer(result.data.documento);
          // converte o array em blob
          let blob = new Blob([bytes], {
            type: "application/pdf",
          });
          // faz download do PDF:
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Parecer ${item.turmaDescricao} - ${item.segmentacaoDescricao}.pdf`;
          link.click();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    visualizar(item) {
      this.$emit("visualizarParecer", item);
    },
  },
};
</script>
